import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NumberInput from '../../../../components/form/NumberInput';

/** Asks how many pieces of a "product × quantity" line to move; `prompt` = { name, max } or null. */
const QuantityModal = ({ prompt, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (prompt) setQuantity(prompt.max);
  }, [prompt]);

  const valid = Number.isInteger(quantity) && quantity >= 1 && quantity <= (prompt?.max ?? 0);
  const submit = (e) => {
    e.preventDefault();
    if (valid) onConfirm(quantity);
  };

  return (
    <Modal show={Boolean(prompt)} onHide={onCancel} centered size="sm">
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>{t('projects.cases.quantityPromptTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label htmlFor="packing-quantity">
            {t('projects.cases.quantityPromptHint', { name: prompt?.name, max: prompt?.max })}
          </Form.Label>
          <NumberInput id="packing-quantity" min={1} max={prompt?.max} value={quantity} onChange={setQuantity} autoFocus />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCancel}>{t('common.cancel')}</Button>
          <Button type="submit" variant="primary" disabled={!valid}>{t('common.confirm')}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default QuantityModal;
